import { Component } from 'react';
import { track } from '../services/firebase';

// Catches render-time errors so a tester never sees a blank white screen.
// Shows a calm recovery card and logs the error to analytics for triage.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    track('app_error', { message: String(error?.message || error).slice(0, 120) });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
        <img src="/logo.svg" alt="GO" className="mb-5 h-10 w-10 rounded-xl" />
        <h1 className="text-lg font-semibold text-[#2d3b2d]">Something hiccuped.</h1>
        <p className="mt-2 max-w-xs text-sm leading-relaxed text-stone-500">
          GO ran into an unexpected snag. A reload usually clears it — your saved
          spots and picks are safe.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="mt-6 rounded-2xl bg-gradient-to-b from-[#3a4d3a] to-[#2d3b2d] px-6 py-3 font-semibold text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.14),0_4px_14px_-4px_rgba(45,59,45,0.5)] active:scale-[0.98]"
        >
          Reload
        </button>
        <a
          href="mailto:support@getoutside.day"
          className="mt-4 text-xs text-stone-400 hover:text-stone-600 hover:underline"
        >
          Still stuck? Tell us
        </a>
      </div>
    );
  }
}
